import { queryOptions } from '@tanstack/react-query';

import { accountService } from '@/services/global-api/account.service';

export const sitemateStartAccountKeys = {
  all: ['sitemate-start-account'] as const,
  detail: (accountId: string | null | undefined) => [...sitemateStartAccountKeys.all, accountId] as const,
};

export const getSitemateStartAccountQueryOptions = ({ accountId }: { accountId: string | null | undefined }) => {
  return queryOptions({
    queryKey: sitemateStartAccountKeys.detail(accountId),
    queryFn: () => {
      if (!accountId) {
        throw new Error('Account ID is required');
      }
      return accountService.getAccountById(accountId);
    },
    enabled: !!accountId,
  });
};
